"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6944],{

/***/ 46385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ FlightOriginDestinationDate; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(71381);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Calendar/index.ts + 9 modules
var Calendar = __webpack_require__(77278);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/form/CalendarDateBlock.tsx
var CalendarDateBlock = __webpack_require__(33935);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/form/DepartureDateInput.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DepartureDateInput = function DepartureDateInput(props) {
  var namespace = props.namespace,
      name = props.name,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var fieldName = name || "departure_date";

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: t("label:common.departureDate"),
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,index_esm/* get */.U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarDateBlock/* CalendarDateBlock */.A, _objectSpread({}, attrs));
};
// EXTERNAL MODULE: ./main/javascripts/utils/DateUtil.ts
var DateUtil = __webpack_require__(16341);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightDateBlock.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var FlightDateBlock = function FlightDateBlock(props) {
  var itineraryGroup = props.itineraryGroup,
      index = props.index,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      onChange = props.onChange;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: ["departure_date", "itineraries"]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 2),
      departureDateValue = _useWatch2[0],
      itinerariesValue = _useWatch2[1];

  var _useState = (0,react.useState)(false),
      displayedCalendar = _useState[0],
      setDisplayedCalendar = _useState[1];

  var inputDepartureDateRef = (0,react.useRef)();

  var val = function val(value) {
    if (itineraryGroup) {
      return "".concat(itineraryGroup, ".").concat(value);
    }

    return value;
  };

  var onClickDepartureDate = function onClickDepartureDate() {
    // inputのonFocusを呼ばないとFormが更新されな
    setDisplayedCalendar(true);
  };

  var hideCalendar = function hideCalendar() {
    setDisplayedCalendar(false);
  };

  var changeNextDateLoop = function changeNextDateLoop(date, index) {
    if (itinerariesValue && itinerariesValue.length > index + 1 && itinerariesValue[index + 1].departure_date) {
      var departureDateObject = (0,DateUtil/* parseDate */.s)(itinerariesValue[index + 1].departure_date);
      var nextIndexDateTime = (0,isDate["default"])(departureDateObject) ? Number((0,format["default"])(departureDateObject, "T")) : 0;

      if (date.getTime() >= nextIndexDateTime) {
        changeNextDate(date, index);
      }
    }
  };

  var changeNextDate = function changeNextDate(date, newIndex) {
    var name = "".concat(itineraryGroup.replace(index, newIndex + 1), ".departure_date");
    var newDate = (0,format["default"])(date.setDate(date.getDate() + 1), "yyyy/LL/dd");
    setValue(name, newDate);
    void trigger(name);
    changeNextDateLoop(date, newIndex + 1);
  };

  var onSelectDeparture = function onSelectDeparture(date) {
    // 選択したらものはfromDateとする
    var departureDateString = (0,format["default"])(date, "yyyy/LL/dd");
    setValue(val("departure_date"), departureDateString);
    void trigger(val("departure_date"));
    changeNextDateLoop(date, Number(index));

    if (onChange) {
      // 周遊のitineraryには対応していないので注意
      onChange(departureDateString);
    }
  }; // const { blockStyle, labelStyle } = styles;


  var onSelect = onSelectDeparture; // const calClassNames: string[] = [
  //   FlightDateBlockStyle.calendarBlock,
  //   FlightDateBlockStyle.calendarRight,
  // ];

  var disableDate = new Date();
  var fromDate = departureDateValue ? (0,DateUtil/* parseDate */.s)(departureDateValue) : new Date();

  if (index && itinerariesValue && itinerariesValue.length > 0) {
    if (itinerariesValue[index - 1] && itinerariesValue[index - 1].departure_date) {
      disableDate = (0,addDays["default"])((0,DateUtil/* parseDate */.s)(itinerariesValue[index - 1].departure_date), 1);
    }

    if (itinerariesValue[index].departure_date) {
      fromDate = (0,DateUtil/* parseDate */.s)(itinerariesValue[index].departure_date);
    }
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: inputBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        name: val("departure_date"),
        isActive: true,
        onClick: onClickDepartureDate,
        inputBlockRef: inputDepartureDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey // styles={{
        //   labelStyle: labelStyle,
        // }}

      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Calendar/* Calendar */.f, {
      fromDate: fromDate,
      toDate: fromDate,
      dateType: Calendar/* FromDateType */.uT,
      onSelect: onSelect,
      hideCalendar: hideCalendar,
      displayedCalendar: displayedCalendar // styles={calClassNames} // TODO: styleどうする？
      ,
      arrowStyleOverride: "right",
      disableDate: disableDate
    })]
  });
};
var blockStyle =  true ? {
  name: "ytouan",
  styles: "position:relative;min-width:9rem"
} : 0;
var inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0); // const calendarBlockStyle = css`
//   min-width: 300px;
//   position: absolute;
//   top: 88px;
//   z-index: 10;
//   box-shadow: 0 6px 30px rgba(40, 40, 40, 0.1);
// `;
// const calendarRightStyle = css`
//   left: auto;
//   right: 0;
// `;
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/DatePicker/index.ts + 2 modules
var DatePicker = __webpack_require__(31264);
// EXTERNAL MODULE: ./main/javascripts/constants/HotelConstants.ts
var HotelConstants = __webpack_require__(10780);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/DatePicker/HorizontalDatePicker.tsx + 1 modules
var HorizontalDatePicker = __webpack_require__(16201);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightDatePickerBlock.tsx


function FlightDatePickerBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var FlightDatePickerBlock = function FlightDatePickerBlock(props) {
  var itineraryGroup = props.itineraryGroup,
      index = props.index,
      _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "tabletLight" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      onChange = props.onChange;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: ["departure_date", "return_date", "itineraries"]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 3),
      departureDateValue = _useWatch2[0],
      returnDateValue = _useWatch2[1],
      itinerariesValue = _useWatch2[2];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputDepartureDateRef = (0,react.useRef)();

  var val = function val(value) {
    if (itineraryGroup) {
      return "".concat(itineraryGroup, ".").concat(value);
    }

    return value;
  };

  var onClickDepartureDate = function onClickDepartureDate() {
    setDisplayedPicker(true);
  };

  var onComplete = function onComplete(startDate, _) {
    if (startDate) {
      var departureDateString = (0,format["default"])(startDate, "yyyy/LL/dd");
      setValue(val("departure_date"), departureDateString);
      void trigger([val("departure_date")]);
      changeNextDateLoop(startDate, Number(index)); // 片道から往復に切り替えた際に不正な範囲にならないよう調整

      if (!itineraryGroup) {
        var returnDateString = returnDateValue;

        if (returnDateString) {
          var returnDate = new Date(returnDateString);

          if (returnDate && !(0,isAfter["default"])(returnDate, startDate)) {
            setValue("return_date", (0,format["default"])((0,addDays["default"])(startDate, 1), "yyyy/LL/dd"));
            void trigger([val("return_date")]);
          }
        }
      }

      if (onChange) {
        // 周遊のitineraryには対応していないので注意
        onChange(departureDateString);
      }
    }

    hidePicker();
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var changeNextDateLoop = function changeNextDateLoop(date, index) {
    if (itinerariesValue && itinerariesValue.length > index + 1 && itinerariesValue[index + 1].departure_date) {
      var departureDateObject = (0,DateUtil/* parseDate */.s)(itinerariesValue[index + 1].departure_date);
      var nextIndexDateTime = (0,isDate["default"])(departureDateObject) ? Number((0,format["default"])(departureDateObject, "T")) : 0;

      if (date.getTime() >= nextIndexDateTime) {
        changeNextDate(date, index);
      }
    }
  };

  var changeNextDate = function changeNextDate(date, newIndex) {
    var name = "".concat(itineraryGroup.replace(index, newIndex + 1), ".departure_date");
    var newDate = (0,format["default"])(date.setDate(date.getDate() + 1), "yyyy/LL/dd");
    setValue(name, newDate);
    void trigger(name);
    changeNextDateLoop(date, newIndex + 1);
  }; // const { blockStyle, labelStyle } = styles;
  // 再レンダリングの負荷が高い場合はメモ化検討する


  var disableDate = new Date();
  var fromDate = departureDateValue ? (0,DateUtil/* parseDate */.s)(departureDateValue) : null;

  if (index && itinerariesValue && itinerariesValue.length > 0) {
    if (itinerariesValue[index - 1] && itinerariesValue[index - 1].departure_date) {
      disableDate = (0,addDays["default"])((0,DateUtil/* parseDate */.s)(itinerariesValue[index - 1].departure_date), 1);
    }

    if (itinerariesValue[index].departure_date) {
      fromDate = (0,DateUtil/* parseDate */.s)(itinerariesValue[index].departure_date);
    }
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FlightDatePickerBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: FlightDatePickerBlock_inputBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        name: val("departure_date"),
        isActive: false,
        onClick: onClickDepartureDate,
        inputBlockRef: inputDepartureDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey
      })
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker/* ScrollableDatePicker */.d, {
        fromDate: fromDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: HotelConstants/* MAX_SEARCH_HOTEL_DAYS */._,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.departureDate"),
        endDateLabel: t("label:common.returnDate"),
        isSingleSelection: true,
        disableDate: disableDate
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalDatePicker/* HorizontalDatePicker */.R, {
      fromDate: fromDate,
      onUpdate: onComplete,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: HotelConstants/* MAX_SEARCH_HOTEL_DAYS */._,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.departureDate"),
      endDateLabel: t("label:common.returnDate"),
      displayedPicker: displayedPicker,
      isSingleSelection: true,
      disableDate: disableDate,
      fromInputRef: inputDepartureDateRef.current
    })]
  });
};
var FlightDatePickerBlock_blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var FlightDatePickerBlock_inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputAutosuggestBlock.tsx
var InputAutosuggestBlock = __webpack_require__(1399);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 2 modules
var store = __webpack_require__(62394);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightDestinationTypes.ts
var FlightDestinationTypes = __webpack_require__(74618);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionFieldButton.tsx
var SuggestionFieldButton = __webpack_require__(83827);
// EXTERNAL MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx + 2 modules
var SuggestionPicker = __webpack_require__(50193);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/components/form/InputHidden.tsx
var InputHidden = __webpack_require__(81047);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightOriginBlock.tsx




















var FlightOriginBlock = function FlightOriginBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      defaultOrigins = props.defaultOrigins,
      suggestOptions = props.suggestOptions,
      itineraryGroup = props.itineraryGroup,
      index = props.index,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling,
      onSelect = props.onSelect;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var isMultiCity = index !== undefined;
  var origins = isMultiCity ? (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightItineraryOriginSuggestionsSelector */.JQ)(state, index || 0);
  }) : (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightOriginSuggestionsSelector */.bZ)(state);
  });
  var isLoading = (0,store/* useAppSelector */.CG)(flightSuggestionSlice/* loadingSelector */.E2);
  var currentInputData = isMultiCity ? (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightItineraryOriginInputDataSelector */.ES)(state, index || 0);
  }) : (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightOriginInputDataSelector */.fm)(state);
  });
  var currentInputText = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.text;
  var currentInputLongName = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.longName; // TODO: 旧reducerをそのまま使用

  var accountDefaultOrigins = (0,es/* useSelector */.v9)(function (state) {
    return state.accountParamsReducer.origins;
  });
  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      trigger = _useFormContext.trigger;

  var fieldName = "origin";
  var idFieldName = "origin_id";
  var typeFieldName = "origin_type";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  }) || "";
  var itineraryValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "".concat(itineraryGroup, ".").concat(fieldName)
  }) || "";

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var originValue = itineraryGroup ? itineraryValue : value;
  var suggestions = originValue ? origins || [] : defaultOrigins || accountDefaultOrigins || [];
  var inputTimeoutRef = (0,react.useRef)(null);
  var valueRef = (0,react.useRef)(originValue);
  valueRef.current = originValue;
  var currentInputLongNameRef = (0,react.useRef)(currentInputLongName);
  currentInputLongNameRef.current = currentInputLongName;
  var currentInputTextRef = (0,react.useRef)(currentInputText);
  currentInputTextRef.current = currentInputText;

  var val = function val(value) {
    if (itineraryGroup) {
      return "".concat(itineraryGroup, ".").concat(value);
    }

    return value;
  };

  var fetchOriginSuggestions = function fetchOriginSuggestions(data) {
    var type = FlightDestinationTypes/* FlightDestinationTypes.origin */.D.origin;
    fetchFlightOriginDestinationSuggestions(data, type, index);
  };

  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    clearTimeout(inputTimeoutRef.current);
    var inputText = valueRef.current;
    setValue(val(fieldName), suggestion.longName);
    setValue(val(idFieldName), suggestion.id);
    setValue(val(typeFieldName), suggestion.destinationType);

    if (isMultiCity) {
      appDispatch((0,flightSuggestionSlice/* setFlightItineraryOriginInputData */.QJ)({
        index: index || 0,
        data: {
          text: inputText,
          longName: suggestion.longName
        }
      }));
    } else {
      appDispatch((0,flightSuggestionSlice/* setFlightOriginInputData */.qH)({
        text: inputText,
        longName: suggestion.longName
      }));
    }

    void trigger([val(fieldName), val(idFieldName)]);

    if (onSelect) {
      onSelect(suggestion);
    }

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(val(idFieldName), null);
    setValue(val(fieldName), "");
    setValue(val(typeFieldName), "");

    if (isMultiCity) {
      appDispatch((0,flightSuggestionSlice/* setFlightItineraryOriginInputData */.QJ)({
        index: index || 0,
        data: {
          text: "",
          longName: ""
        }
      }));
    } else {
      appDispatch((0,flightSuggestionSlice/* setFlightOriginInputData */.qH)({
        text: "",
        longName: ""
      }));
    }
  };

  var onFocus = function onFocus() {
    clearTimeout(inputTimeoutRef.current); // setValue(fieldName, currentInputText);

    var inputText = currentInputTextRef.current;
    setValue(val(fieldName), inputText);

    if (inputText) {
      fetchOriginSuggestions({
        text: inputText
      });
    }
  };

  var onBlur = function onBlur() {
    // onSelectedより先に呼ばれるため遅延させる
    inputTimeoutRef.current = setTimeout(function () {
      if (currentInputLongNameRef.current && valueRef.current !== currentInputLongNameRef.current) {
        setValue(val(fieldName), currentInputLongNameRef.current);
        void trigger(val(fieldName));
      }
    }, 400);
  };

  var error = (0,index_esm/* get */.U2)(errors, val(fieldName)) || (0,index_esm/* get */.U2)(errors, val(idFieldName));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FlightOriginBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHidden/* InputHidden */.R, {
      name: idFieldName
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHidden/* InputHidden */.R, {
      name: typeFieldName
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionFieldButton/* SuggestionFieldButton */.M, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        name: val(fieldName),
        label: {
          namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
          label: t("label:common.origin"),
          colorStyleKey: labelColorStyleKey
        },
        longName: originValue,
        placeholder: t("form.placeholders.flight.originPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        error: error
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: headerTitleStyle,
          children: t("label:common.origin")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionPicker/* SuggestionPicker */.W, {
          name: val(fieldName),
          suggestions: suggestions,
          placeholder: t("form.placeholders.flight.originPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchOriginSuggestions,
          onSelected: onSelected,
          onFocus: onFocus,
          onBlur: onBlur,
          onClear: onClearInput
        })]
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAutosuggestBlock/* InputAutosuggestBlock */.A, {
      namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
      label: {
        namespace: "common",
        label: t("label:common.origin"),
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: val(fieldName),
        value: originValue,
        type: "text",
        placeholder: t("form.placeholders.flight.originPlaceholder")
      },
      error: error,
      suggestOptions: suggestOptions,
      fetchDestinationSuggest: fetchOriginSuggestions,
      suggestions: suggestions,
      onSelected: onSelected,
      onFocus: onFocus,
      onBlur: onBlur,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey
    })]
  });
};
var FlightOriginBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;flex-grow:2;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightDestinationBlock.tsx



















var FlightDestinationBlock = function FlightDestinationBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      itineraryGroup = props.itineraryGroup,
      index = props.index,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling,
      onSelect = props.onSelect;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var isMultiCity = index !== undefined;
  var destinations = isMultiCity ? (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightItineraryDestinationSuggestionsSelector */.zY)(state, index || 0);
  }) : (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightDestinationSuggestionsSelector */.ts)(state);
  });
  var isLoading = (0,store/* useAppSelector */.CG)(flightSuggestionSlice/* loadingSelector */.E2);
  var currentInputData = isMultiCity ? (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightItineraryDestinationInputDataSelector */.d3)(state, index || 0);
  }) : (0,store/* useAppSelector */.CG)(function (state) {
    return (0,flightSuggestionSlice/* flightDestinationInputDataSelector */.zI)(state);
  });
  var currentInputText = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.text;
  var currentInputLongName = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.longName; // TODO: 旧reducerをそのまま使用

  var accountDefaultDestinations = (0,es/* useSelector */.v9)(function (state) {
    return state.accountParamsReducer.destinations;
  });
  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      trigger = _useFormContext.trigger;

  var fieldName = "destination";
  var idFieldName = "destination_id";
  var typeFieldName = "destination_type";
  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  }) || "";
  var itineraryValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "".concat(itineraryGroup, ".").concat(fieldName)
  }) || "";
  var itinerariesValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "itineraries"
  }) || [];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var destinationValue = itineraryGroup ? itineraryValue : value;
  var suggestions = destinationValue ? destinations || [] : defaultDestinations || accountDefaultDestinations || [];
  var inputTimeoutRef = (0,react.useRef)(null);
  var valueRef = (0,react.useRef)(destinationValue);
  valueRef.current = destinationValue;
  var currentInputLongNameRef = (0,react.useRef)(currentInputLongName);
  currentInputLongNameRef.current = currentInputLongName;
  var currentInputTextRef = (0,react.useRef)(currentInputText);
  currentInputTextRef.current = currentInputText;

  var val = function val(value) {
    if (itineraryGroup) {
      return "".concat(itineraryGroup, ".").concat(value);
    }

    return value;
  };

  var fetchDestinationSuggestions = function fetchDestinationSuggestions(data) {
    var type = FlightDestinationTypes/* FlightDestinationTypes.destination */.D.destination;
    fetchFlightOriginDestinationSuggestions(data, type, index);
  };

  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    clearTimeout(inputTimeoutRef.current);
    var inputText = valueRef.current;
    setValue(val(fieldName), suggestion.longName);
    setValue(val(idFieldName), suggestion.id);
    setValue(val(typeFieldName), suggestion.destinationType);

    if (itinerariesValue && itinerariesValue.length > Number(index) + 1 && !itinerariesValue[Number(index) + 1].origin) {
      var name = itineraryGroup.replace(index, Number(index) + 1);
      setValue("".concat(name, ".origin"), suggestion.longName);
      setValue("".concat(name, ".origin_id"), suggestion.id);
      setValue("".concat(name, ".origin_type"), suggestion.destinationType);
    }

    if (isMultiCity) {
      appDispatch((0,flightSuggestionSlice/* setFlightItineraryDestinationInputData */.Sw)({
        index: index || 0,
        data: {
          text: inputText,
          longName: suggestion.longName
        }
      }));
    } else {
      appDispatch((0,flightSuggestionSlice/* setFlightDestinationInputData */.IO)({
        text: inputText,
        longName: suggestion.longName
      }));
    }

    void trigger([val(fieldName), val(idFieldName)]);

    if (onSelect) {
      onSelect(suggestion);
    }

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(val(fieldName), "");
    setValue(val(idFieldName), null);
    setValue(val(typeFieldName), "");

    if (isMultiCity) {
      appDispatch((0,flightSuggestionSlice/* setFlightItineraryDestinationInputData */.Sw)({
        index: index || 0,
        data: {
          text: "",
          longName: ""
        }
      }));
    } else {
      appDispatch((0,flightSuggestionSlice/* setFlightDestinationInputData */.IO)({
        text: "",
        longName: ""
      }));
    }
  };

  var onFocus = function onFocus() {
    clearTimeout(inputTimeoutRef.current); // setValue(fieldName, currentInputText);

    var inputText = currentInputTextRef.current;
    setValue(val(fieldName), inputText);

    if (inputText) {
      fetchDestinationSuggestions({
        text: inputText
      });
    }
  };

  var onBlur = function onBlur() {
    // onSelectedより先に呼ばれるため遅延させる
    inputTimeoutRef.current = setTimeout(function () {
      if (currentInputLongNameRef.current && valueRef.current !== currentInputLongNameRef.current) {
        setValue(val(fieldName), currentInputLongNameRef.current);
        void trigger(fieldName);
      }
    }, 400);
  };

  var error = (0,index_esm/* get */.U2)(errors, val(fieldName)) || (0,index_esm/* get */.U2)(errors, val(idFieldName));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: FlightDestinationBlock_blockStyle,
    children: (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionFieldButton/* SuggestionFieldButton */.M, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        name: val(fieldName),
        label: {
          namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
          label: t("label:common.destination"),
          colorStyleKey: labelColorStyleKey
        },
        longName: destinationValue,
        placeholder: t("form.placeholders.flight.originPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        error: error
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: FlightDestinationBlock_headerTitleStyle,
          children: t("label:common.destination")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionPicker/* SuggestionPicker */.W, {
          name: val(fieldName),
          suggestions: suggestions,
          placeholder: t("form.placeholders.flight.originPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchDestinationSuggestions,
          onSelected: onSelected,
          onFocus: onFocus,
          onBlur: onBlur,
          onClear: onClearInput
        })]
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAutosuggestBlock/* InputAutosuggestBlock */.A, {
      namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
      label: {
        namespace: "common",
        label: t("label:common.destination"),
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: val(fieldName),
        value: destinationValue,
        type: "text",
        placeholder: t("form.placeholders.flight.originPlaceholder")
      },
      error: error,
      fetchDestinationSuggest: fetchDestinationSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onSelected: onSelected,
      onFocus: onFocus,
      onBlur: onBlur,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey
    })
  });
};
var FlightDestinationBlock_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;flex-grow:2;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var FlightDestinationBlock_headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:bold;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/constants/GoogleTagManagerEventTypes.ts
var GoogleTagManagerEventTypes = __webpack_require__(12327);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightOneWayBlock.tsx













var FlightOneWayBlock = function FlightOneWayBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      itineraryGroup = props.itineraryGroup,
      defaultOrigins = props.defaultOrigins,
      defaultDestinations = props.defaultDestinations,
      useDatePicker = props.useDatePicker,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey; // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var onOriginSelect = function onOriginSelect(suggestion) {
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.origin */.T.origin, {
      origin_id: suggestion.id,
      origin_type: suggestion.destinationType,
      origin: suggestion.longName
    });
  };

  var onDestinationSelect = function onDestinationSelect(suggestion) {
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.origin */.T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });
  };

  var onDateChange = function onDateChange(departureDate) {
    if (departureDate) {
      (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.date */.T.date, {
        start_date: departureDate
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: firstBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultOrigins: defaultOrigins,
        suggestOptions: {
          included_code: "JP"
        } // 国内のみ表示
        ,
        itineraryGroup: itineraryGroup,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onSelect: onOriginSelect
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDestinationBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultDestinations: defaultDestinations,
        suggestOptions: {
          excluded_code: "JP"
        } // 海外のみ表示
        ,
        itineraryGroup: itineraryGroup,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onSelect: onDestinationSelect
      }), useDatePicker && breakpoint ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDatePickerBlock, {
        itineraryGroup: itineraryGroup,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onChange: onDateChange
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDateBlock, {
        itineraryGroup: itineraryGroup,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onChange: onDateChange
      })]
    })
  });
};
var firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(92300);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/form/ReturnDateInput.tsx


function ReturnDateInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReturnDateInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReturnDateInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReturnDateInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ReturnDateInput = function ReturnDateInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var fieldName = "return_date";

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: t("label:common.returnDate"),
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,index_esm/* get */.U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarDateBlock/* CalendarDateBlock */.A, ReturnDateInput_objectSpread({}, attrs));
};
// EXTERNAL MODULE: ./main/javascripts/constants/SearchCategories.ts
var SearchCategories = __webpack_require__(80264);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightRoundTripDateBlock.tsx


function FlightRoundTripDateBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var FlightRoundTripDateBlock = function FlightRoundTripDateBlock(props) {
  var searchType = props.searchType,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      onChange = props.onChange;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: ["departure_date", "return_date"]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 2),
      departureDateValue = _useWatch2[0],
      returnDateValue = _useWatch2[1];

  var _useState = (0,react.useState)(false),
      displayedCalendar = _useState[0],
      setDisplayedCalendar = _useState[1];

  var _useState2 = (0,react.useState)(null),
      dateType = _useState2[0],
      setDateType = _useState2[1];

  var inputDepartureDateRef = (0,react.useRef)();
  var inputReturnDateRef = (0,react.useRef)();

  var onClickDepartureDate = function onClickDepartureDate() {
    // inputのonFocusを呼ばないとFormが更新されな
    setDisplayedCalendar(true);
    setDateType(Calendar/* FromDateType */.uT);
  };

  var onClickReturnDate = function onClickReturnDate() {
    // inputのonFocusを呼ばないとFormが更新されない
    setDisplayedCalendar(true);
    setDateType(Calendar/* ToDateType */.ql);
  };

  var hideCalendar = function hideCalendar() {
    setDisplayedCalendar(false);
  };

  var isInvalidDate = function isInvalidDate(startDate, endDate) {
    if (searchType === SearchCategories/* searchCategories.flight */.M.flight) {
      return (0,differenceInCalendarDays["default"])(endDate, startDate) < 0;
    }

    return (0,differenceInCalendarDays["default"])(endDate, startDate) <= 0;
  };

  var onSelectDeparture = function onSelectDeparture(date) {
    var departureDateString = "";
    var returnDateString = returnDateValue;
    var parsed_return_date = (0,DateUtil/* parseDate */.s)(returnDateValue); // toDateがnullや選択日以前であれば、toDateをfromDateの1日後とする

    if (returnDateValue === null || isInvalidDate(date, parsed_return_date)) {
      returnDateString = (0,format["default"])((0,addDays["default"])(date, 1), "yyyy/LL/dd");
      setValue("return_date", returnDateString);
    } // 選択したらものはfromDateとする


    departureDateString = (0,format["default"])(date, "yyyy/LL/dd");
    setValue("departure_date", departureDateString);
    void trigger(["departure_date"]);

    if (onChange) {
      onChange(departureDateString, returnDateString);
    }
  };

  var onSelectReturn = function onSelectReturn(date) {
    var departureDateString = departureDateValue;
    var returnDateString = "";
    var parsed_departure_date = (0,DateUtil/* parseDate */.s)(departureDateValue); // fromDateがnullや選択日以後の場合は、fromDateはtoDateの1日前とする

    if (departureDateValue === null || isInvalidDate(parsed_departure_date, date)) {
      departureDateString = (0,format["default"])((0,subDays["default"])(date, 1), "yyyy/LL/dd");
      setValue("departure_date", departureDateString);
    }

    returnDateString = (0,format["default"])(date, "yyyy/LL/dd");
    setValue("return_date", returnDateString);
    void trigger(["return_date"]);

    if (onChange) {
      onChange(departureDateString, returnDateString);
    }
  };

  var onSelect = dateType === Calendar/* FromDateType */.uT ? onSelectDeparture : onSelectReturn; // TODO
  // const calClassNames: string[] = [
  //   FlightRoundTripDateBlockStyle.calendarBlock,
  // ];
  // if (dateType === ToDateType) {
  //   calClassNames.push(FlightRoundTripDateBlockStyle.calendarRight);
  // }

  var fromDate = departureDateValue ? (0,DateUtil/* parseDate */.s)(departureDateValue) : null;
  var toDate = returnDateValue ? (0,DateUtil/* parseDate */.s)(returnDateValue) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FlightRoundTripDateBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: FlightRoundTripDateBlock_inputBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        isActive: dateType === Calendar/* FromDateType */.uT,
        onClick: onClickDepartureDate,
        inputBlockRef: inputDepartureDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey // styles={{
        //   labelStyle: labelStyle,
        // }}

      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        isActive: dateType === Calendar/* ToDateType */.ql,
        onClick: onClickReturnDate,
        inputBlockRef: inputReturnDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey // styles={{
        //   labelStyle: labelStyle,
        // }}

      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Calendar/* Calendar */.f, {
      fromDate: fromDate,
      toDate: toDate,
      dateType: dateType,
      onSelect: onSelect,
      hideCalendar: hideCalendar,
      displayedCalendar: displayedCalendar // styles={calClassNames} // TODO: styleどうする？

    })]
  });
};
var FlightRoundTripDateBlock_blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var FlightRoundTripDateBlock_inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/constants/DateTypes.ts
var DateTypes = __webpack_require__(71797);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightRoundTripDatePickerBlock.tsx


function FlightRoundTripDatePickerBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var FlightRoundTripDatePickerBlock = function FlightRoundTripDatePickerBlock(props) {
  var searchType = props.searchType,
      _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "tabletLight" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling,
      onChange = props.onChange;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: ["departure_date", "return_date"]
  }),
      _useWatch2 = (0,slicedToArray/* default */.Z)(_useWatch, 2),
      departureDateValue = _useWatch2[0],
      returnDateValue = _useWatch2[1];

  var _useState = (0,react.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputDepartureDateRef = (0,react.useRef)();
  var inputReturnDateRef = (0,react.useRef)();

  var onClickDepartureDate = function onClickDepartureDate() {
    setDisplayedPicker(true);
    setPickerDateType(DateTypes/* DateTypes.fromDate */.t.fromDate);
  };

  var onClickReturnDate = function onClickReturnDate() {
    setDisplayedPicker(true);
    setPickerDateType(DateTypes/* DateTypes.toDate */.t.toDate);
  };

  var onComplete = function onComplete(startDate, endDate) {
    var departureDateString = "";
    var returnDateString = "";

    if (startDate) {
      departureDateString = (0,format["default"])(startDate, "yyyy/LL/dd");
      setValue("departure_date", departureDateString);
      void trigger(["departure_date"]);
    }

    if (endDate) {
      returnDateString = (0,format["default"])(endDate, "yyyy/LL/dd");
      setValue("return_date", returnDateString);
      void trigger(["return_date"]);
    }

    if (onChange) {
      onChange(departureDateString, returnDateString);
    }

    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var departureDateString = "";
    var returnDateString = "";

    if (startDate) {
      departureDateString = (0,format["default"])(startDate, "yyyy/LL/dd");
      setValue("departure_date", departureDateString);
      void trigger(["departure_date"]);
    }

    if (endDate) {
      returnDateString = (0,format["default"])(endDate, "yyyy/LL/dd");
      setValue("return_date", returnDateString);
      void trigger(["return_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(DateTypes/* DateTypes.toDate */.t.toDate);
    }

    if (onChange) {
      onChange(departureDateString, returnDateString);
    }
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  }; // const { blockStyle, labelStyle } = styles;


  var fromDate = departureDateValue ? (0,DateUtil/* parseDate */.s)(departureDateValue) : null;
  var toDate = returnDateValue ? (0,DateUtil/* parseDate */.s)(returnDateValue) : null;
  var canSelectSameDate = searchType === SearchCategories/* searchCategories.flight */.M.flight;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: FlightRoundTripDatePickerBlock_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: FlightRoundTripDatePickerBlock_inputBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DepartureDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        isActive: pickerDateType === DateTypes/* DateTypes.fromDate */.t.fromDate,
        onClick: onClickDepartureDate,
        inputBlockRef: inputDepartureDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnDateInput, {
        namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
        isActive: pickerDateType === DateTypes/* DateTypes.toDate */.t.toDate,
        onClick: onClickReturnDate,
        inputBlockRef: inputReturnDateRef,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey
      })]
    }), (0,responsiveStyle/* isPhone */.Mn)(breakpoint) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker/* ScrollableDatePicker */.d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: HotelConstants/* MAX_SEARCH_HOTEL_DAYS */._,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.departureDate"),
        endDateLabel: t("label:common.returnDate"),
        dateType: pickerDateType,
        canSelectSameDate: canSelectSameDate
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalDatePicker/* HorizontalDatePicker */.R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: HotelConstants/* MAX_SEARCH_HOTEL_DAYS */._,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.departureDate"),
      endDateLabel: t("label:common.returnDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputDepartureDateRef.current,
      toInputRef: inputReturnDateRef.current,
      canSelectSameDate: canSelectSameDate
    })]
  });
};
var FlightRoundTripDatePickerBlock_blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var FlightRoundTripDatePickerBlock_inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightRoundTripBlock.tsx













var FlightRoundTripBlock = function FlightRoundTripBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      defaultOrigins = props.defaultOrigins,
      defaultDestinations = props.defaultDestinations,
      destinationSuggestOptions = props.destinationSuggestOptions,
      useDatePicker = props.useDatePicker,
      searchType = props.searchType,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling; // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var onOriginSelect = function onOriginSelect(suggestion) {
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.origin */.T.origin, {
      origin_id: suggestion.id,
      origin_type: suggestion.destinationType,
      origin: suggestion.longName
    });
  };

  var onDestinationSelect = function onDestinationSelect(suggestion) {
    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.origin */.T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });
  };

  var onDateChange = function onDateChange(departureDate, returnDate) {
    if (departureDate && returnDate) {
      (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.date */.T.date, {
        start_date: departureDate,
        end_date: returnDate
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: FlightRoundTripBlock_firstBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultOrigins: defaultOrigins,
        suggestOptions: {
          included_code: "JP"
        } // 国内のみ表示
        ,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        disableStopBodyScrolling: disableStopBodyScrolling,
        onSelect: onOriginSelect
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDestinationBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultDestinations: defaultDestinations,
        suggestOptions: destinationSuggestOptions,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        disableStopBodyScrolling: disableStopBodyScrolling,
        onSelect: onDestinationSelect
      })]
    }), useDatePicker && breakpoint ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightRoundTripDatePickerBlock, {
      searchType: searchType,
      labelColorStyleKey: labelColorStyleKey,
      borderColorStyleKey: borderColorStyleKey,
      disableStopBodyScrolling: disableStopBodyScrolling,
      onChange: onDateChange
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightRoundTripDateBlock, {
      searchType: searchType,
      labelColorStyleKey: labelColorStyleKey,
      borderColorStyleKey: borderColorStyleKey,
      onChange: onDateChange
    })]
  });
};
var FlightRoundTripBlock_firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightMultiCityBlock.tsx













var FlightMultiCityBlock = function FlightMultiCityBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      itineraryGroup = props.itineraryGroup,
      index = props.index,
      defaultOrigins = props.defaultOrigins,
      defaultDestinations = props.defaultDestinations,
      useDatePicker = props.useDatePicker,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      onSelect = props.onSelect; // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: FlightMultiCityBlock_firstBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultOrigins: defaultOrigins,
        itineraryGroup: itineraryGroup,
        index: index,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onSelect: onSelect
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDestinationBlock, {
        fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
        defaultDestinations: defaultDestinations,
        itineraryGroup: itineraryGroup,
        index: index,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onSelect: onSelect
      }), useDatePicker && breakpoint ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDatePickerBlock, {
        itineraryGroup: itineraryGroup,
        index: index,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onChange: onSelect
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightDateBlock, {
        itineraryGroup: itineraryGroup,
        index: index,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        onChange: onSelect
      })]
    })
  });
};
var FlightMultiCityBlock_firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin-bottom:", spaceStyle/* space.atom */.D.atom, ";&:after{content:\"\";display:block;padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";margin:0 ", spaceStyle/* space.atom */.D.atom, ";border-bottom:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;padding-bottom:0;&:after{content:none;}}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/button/Button.tsx
var Button = __webpack_require__(95284);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightMultiCityListBlock.tsx












var minItineraries = 2;
var maxItineraries = 6;
var FlightMultiCityListBlock = function FlightMultiCityListBlock(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      defaultOrigins = props.defaultOrigins,
      defaultDestinations = props.defaultDestinations,
      useDatePicker = props.useDatePicker,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var _useFieldArray = (0,index_esm/* useFieldArray */.Dq)({
    control: control,
    name: "itineraries"
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var itinerariesValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "itineraries"
  }) || [];
  var itinerariesRef = (0,react.useRef)(itinerariesValue);
  itinerariesRef.current = itinerariesValue;
  var selectCountRef = (0,react.useRef)(0);
  (0,react.useEffect)(function () {
    if (selectCountRef.current === 0) {
      return;
    }

    (0,googleTagManagerUtil/* event */.B)(GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.itineraries */.T.itineraries, {
      itineraries: itinerariesValue
    });
  }, [selectCountRef.current]);

  var addItinerary = function addItinerary() {
    var prevDestination = itinerariesValue[itinerariesValue.length - 1].destination;
    var prevDestinationId = itinerariesValue[itinerariesValue.length - 1].destination_id;
    var prevDestinationType = itinerariesValue[itinerariesValue.length - 1].destination_type;
    append({
      origin: prevDestination ? prevDestination : null,
      origin_id: prevDestinationId ? prevDestinationId : null,
      origin_type: prevDestinationType ? prevDestinationType : null
    });
  };

  var removeItinerary = function removeItinerary() {
    remove(itinerariesValue.length - 1);
  };

  var addItineraryButton = {
    onClick: addItinerary,
    text: "+ 区間を追加"
  };
  var removeItineraryButton = {
    onClick: removeItinerary,
    text: "- 区間を削除"
  };

  var onSelect = function onSelect() {
    // この時点ではitinerariesValueがまだ更新されていないため
    // アップデートフラグを更新する
    selectCountRef.current = selectCountRef.current + 1;
  };

  var renderItineraryFields = function renderItineraryFields() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: fields.map(function (field, index) {
        var itinerary = itinerariesValue[index];
        var itineraryGroup = "itineraries.".concat(index);

        if (!itinerary) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, itineraryGroup);
        }

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightMultiCityBlock, {
          fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
          itineraryGroup: itineraryGroup,
          index: index,
          defaultOrigins: defaultOrigins,
          defaultDestinations: defaultDestinations,
          useDatePicker: useDatePicker,
          labelColorStyleKey: labelColorStyleKey,
          borderColorStyleKey: borderColorStyleKey,
          onSelect: onSelect
        }, field.id);
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [renderItineraryFields(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: buttonsBlockStyle,
      children: [itinerariesValue.length > minItineraries ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: buttonBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          type: "button",
          styleKey: "buttonRemove",
          onClick: removeItineraryButton.onClick,
          children: removeItineraryButton.text
        })
      }) : "", itinerariesValue.length < maxItineraries ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: buttonBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          type: "button",
          styleKey: "buttonAdd",
          onClick: addItineraryButton.onClick,
          children: addItineraryButton.text
        })
      }) : ""]
    })]
  });
};
var buttonsBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;justify-content:flex-end;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0 0;}" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:calc(50% - ", spaceStyle/* space.atom2x */.D.atom2x, ");padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:120px;padding:0 ", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
;// CONCATENATED MODULE: ./main/javascripts/components/flight/FlightOriginDestinationDate.tsx


function FlightOriginDestinationDate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FlightOriginDestinationDate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FlightOriginDestinationDate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FlightOriginDestinationDate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var FlightOriginDestinationDate = function FlightOriginDestinationDate(props) {
  var fetchFlightOriginDestinationSuggestions = props.fetchFlightOriginDestinationSuggestions,
      defaultOrigins = props.defaultOrigins,
      defaultDestinations = props.defaultDestinations,
      destinationSuggestOptions = props.destinationSuggestOptions,
      useDatePicker = props.useDatePicker,
      searchType = props.searchType,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      control = _useFormContext.control;

  var flightTypeValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: "flight_type"
  });

  var renderItinerary = function renderItinerary(flightType, props) {
    switch (flightType) {
      case FlightTypes/* FlightTypes.roundTrip */.z.roundTrip:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightRoundTripBlock, FlightOriginDestinationDate_objectSpread(FlightOriginDestinationDate_objectSpread({}, props), {}, {
          defaultOrigins: defaultOrigins,
          defaultDestinations: defaultDestinations,
          destinationSuggestOptions: {
            excluded_code: "JP"
          },
          useDatePicker: useDatePicker,
          searchType: searchType,
          labelColorStyleKey: labelColorStyleKey,
          borderColorStyleKey: borderColorStyleKey,
          disableStopBodyScrolling: disableStopBodyScrolling
        }));

      case FlightTypes/* FlightTypes.multiCity */.z.multiCity:
        {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightMultiCityListBlock, FlightOriginDestinationDate_objectSpread(FlightOriginDestinationDate_objectSpread({}, props), {}, {
            defaultOrigins: defaultOrigins,
            defaultDestinations: defaultDestinations,
            useDatePicker: useDatePicker,
            labelColorStyleKey: labelColorStyleKey,
            borderColorStyleKey: borderColorStyleKey,
            disableStopBodyScrolling: disableStopBodyScrolling
          }));
        }

      default:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOneWayBlock, FlightOriginDestinationDate_objectSpread(FlightOriginDestinationDate_objectSpread({}, props), {}, {
          defaultOrigins: defaultOrigins,
          defaultDestinations: defaultDestinations,
          useDatePicker: useDatePicker,
          labelColorStyleKey: labelColorStyleKey,
          borderColorStyleKey: borderColorStyleKey,
          disableStopBodyScrolling: disableStopBodyScrolling
        }));
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: renderItinerary(flightTypeValue, {
      fetchFlightOriginDestinationSuggestions: fetchFlightOriginDestinationSuggestions,
      destinationSuggestOptions: destinationSuggestOptions // styles: styles,

    })
  });
};

/***/ }),

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FlightTravelerBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82600);
/* harmony import */ var main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77562);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36581);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var FlightTravelerBlock = function FlightTravelerBlock(props) {
  var labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var MAX_ADULT_NUM = 8;
  var MAX_CHILD_NUM = 8;
  var MAX_CHILD_AGE = 11;

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors;

  var values = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useWatch */ .qo)();

  var _useFieldArray = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useFieldArray */ .Dq)({
    name: "traveler.ages_of_children"
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var valuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(values);
  valuesRef.current = values;

  var renderChildAge = function renderChildAge(index) {
    var fieldName = "traveler.ages_of_children.".concat(index, ".age");
    var optionList = [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
      value: "",
      disabled: true,
      children: "\u5E74\u9F62"
    }, "none")]; // const { ageInputStyle, ageInputMultiStyle, labelAgeStyle } = styles;
    //
    // const propStyle: any =
    //   Number(values.flightTraveler_num || 1) === 1
    //     ? ageInputStyle
    //     : ageInputMultiStyle;
    // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_CHILD_AGE + 1).keys()).map(function (childAge) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: childAge,
        children: "".concat(childAge, " \u6B73")
      }, childAge));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
      namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
      // styles={[
      //   FlightTravelerBlockStyle.flightTravelerInputBlockSmall,
      //   propStyle,
      // ]}
      label: {
        namespace: "common",
        label: t("label:common.flightAgesOfChildren", {
          index: Number(index) + 1
        }),
        colorStyleKey: labelColorStyleKey // styles: [FlightTravelerBlockStyle.childLabel, labelAgeStyle],

      },
      select: {
        name: fieldName,
        children: optionList
      },
      error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
      borderColorStyleKey: borderColorStyleKey
    }, index);
  };

  var renderNumberOfChildren = function renderNumberOfChildren() {
    var fieldName = "traveler.number_of_children";
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_CHILD_NUM + 1 - (values.traveler.number_of_adult || 0)).keys()).map(function (childNum) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: childNum,
        children: "".concat(childNum, " \u4EBA")
      }, childNum));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: flightTravelerInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
        label: {
          namespace: "common",
          label: t("label:common.flightNumberOfChildren"),
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          onChange: onChangeNumberOfChildren(),
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  };

  var renderNumberOfAdult = function renderNumberOfAdult() {
    var fieldName = "traveler.number_of_adult";
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_ADULT_NUM - (values.traveler.number_of_children || 0)).keys()).map(function (adultNum) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: adultNum + 1,
        children: "".concat(adultNum + 1, " \u4EBA")
      }, adultNum));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: flightTravelerInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
        label: {
          namespace: "common",
          label: t("label:common.flightNumberOfAdult"),
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  }; // useFieldArrayではオブジェクト単位で追加する必要があり
  // indexで終わるkeyに対して値を追加できないため
  // .ageで管理し、リクエスト時に整形する


  var onChangeNumberOfChildren = function onChangeNumberOfChildren() {
    return function (e) {
      var oldNumberOfChildren = parseInt(valuesRef.current.traveler.number_of_children, 10);
      var numberOfChildren = parseInt(e.target.value, 10);
      setValue("traveler.number_of_children", numberOfChildren);

      if (oldNumberOfChildren > numberOfChildren) {
        remove((0,main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__/* .rangexy */ .w)(numberOfChildren, oldNumberOfChildren));
      } else if (oldNumberOfChildren < numberOfChildren) {
        (0,main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__/* .rangexy */ .w)(oldNumberOfChildren, numberOfChildren).map(function (_) {
          append({
            age: ""
          });
        });
      }
    };
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
    css: flightTravelerBlockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
      css: flightTravelerInputGroupBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        css: flightTravelerInputGroupBlockMediumStyle,
        children: [renderNumberOfAdult(), renderNumberOfChildren()]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
        css: flightTravelerInputGroupBlockStyle,
        children: fields.map(function (field, index) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
            css: flightTravelerInputBlockSmallStyle,
            children: renderChildAge(index)
          }, field.id);
        })
      })]
    })
  });
};
var flightTravelerBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("display:flex;flex-wrap:wrap;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var flightTravelerInputGroupBlockStyle =  true ? {
  name: "798ujy",
  styles: "width:100%;display:flex;flex-wrap:wrap"
} : 0;
var flightTravelerInputBlockStyle =  true ? {
  name: "1t29t6p",
  styles: "width:50%"
} : 0;
var flightTravelerInputGroupBlockMediumStyle =  true ? {
  name: "do4vze",
  styles: "width:66.666%;display:flex"
} : 0;
var flightTravelerInputBlockSmallStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("width:33.333%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), "{width:25%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 84077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CabinClassBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82600);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36581);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var CabinClassTypes = [{
  value: "Y",
  label: "economy"
}, {
  value: "W",
  label: "economyPremium"
}, {
  value: "C",
  label: "business"
}, {
  value: "F",
  label: "first"
}];
var CabinClassBlock = function CabinClassBlock(props) {
  var labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      errors = props.errors;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(["constant", "label"]),
      t = _useTranslation.t;

  var optionList = []; // const { innerBlockStyle = {}, labelStyle } = styles;

  CabinClassTypes.map(function (option) {
    optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("option", {
      value: option.value,
      children: t("flightClass.".concat(option.label))
    }, option.value));
  });
  var fieldName = "cabin_class";
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: flightClassBlockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
      namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_3__/* .FormNamespaces.flight */ .Z.flight,
      label: {
        namespace: "common",
        label: t("label:common.bookingClass"),
        colorStyleKey: labelColorStyleKey
      },
      select: {
        name: fieldName,
        children: optionList
      },
      error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
      borderColorStyleKey: borderColorStyleKey
    })
  });
};
var flightClassBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0); // const flightClassInputBlockStyle = css`
//   width: 50%;
//   min-width: 200px;
// `;

/***/ }),

/***/ 28090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FlightTypeBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_RadioButtonBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);





var FlightTypeBlock = function FlightTypeBlock(props) {
  var labelStyleKey = props.labelStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      errors = props.errors;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)(["constant"]),
      t = _useTranslation.t;

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      clearErrors = _useFormContext.clearErrors;

  var fieldName = "flight_type";
  var checkedValue = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    clearErrors();
  }, [checkedValue]);
  var flightTypes = [{
    text: t("flightType.oneWay"),
    value: "one_way"
  }, {
    text: t("flightType.roundTrip"),
    value: "round_trip"
  }, {
    text: t("flightType.multiCity"),
    value: "multi_city"
  }];
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_RadioButtonBlock__WEBPACK_IMPORTED_MODULE_1__/* .RadioButtonBlock */ .r, {
      namespace: "flight",
      checkedValue: checkedValue,
      options: flightTypes,
      input: {
        name: fieldName
      },
      error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
      labelStyleKey: labelStyleKey,
      borderColorStyleKey: borderColorStyleKey,
      displayStyle: "flex",
      widthStyle: "auto"
    })
  });
};

/***/ })

}]);